import { xUserInfo } from "../web3/Types";
import { USDC } from "./UsdcValue";
import { Ticket } from "./Ticket";

export class UserInfo {
  points: number;
  toClaim: USDC;
  isCharity: boolean;
  hasBeenCharity: boolean;
  donationsToClaim: USDC;
  isOwner: boolean;
  royaltiesToClaim: USDC;
  ticketsBought: Ticket[];

  constructor(
    points: number,
    toClaim: USDC,
    isCharity: boolean,
    hasBeenCharity: boolean,
    donationsToClaim: USDC,
    isOwner: boolean,
    royaltiesToClaim: USDC,
    ticketsBought: Ticket[],
  ) {
    this.points = points;
    this.toClaim = toClaim;
    this.isCharity = isCharity;
    this.hasBeenCharity = hasBeenCharity;
    this.donationsToClaim = donationsToClaim;
    this.isOwner = isOwner;
    this.royaltiesToClaim = royaltiesToClaim;
    this.ticketsBought = ticketsBought;
  }

  static fromUserInfo(struct: xUserInfo): UserInfo {
    return new UserInfo(
      Number(struct.player.points),
      new USDC(struct.player.unclaimedPrizes),
      struct.charity.node.active,
      struct.charity.info.name != undefined,
      struct.charity.node.active
        ? new USDC(struct.charity.unclaimedDonations)
        : new USDC(0n),
      struct.isOwner,
      new USDC(0n), // TODO: Replace this
      struct.currentTickets
        .map((ticket) => Ticket.fromTicket(ticket))
        .reverse(),
    );
  }

  updateToClaim(
    prizesToClaim?: bigint,
    donationsToClaim?: bigint,
    royaltiesToClaim?: bigint,
  ): UserInfo {
    return new UserInfo(
      this.points,
      prizesToClaim !== undefined ? new USDC(prizesToClaim) : this.toClaim,
      this.isCharity,
      this.hasBeenCharity,
      donationsToClaim !== undefined
        ? new USDC(donationsToClaim)
        : this.donationsToClaim,
      this.isOwner,
      royaltiesToClaim !== undefined
        ? new USDC(royaltiesToClaim)
        : this.royaltiesToClaim,
      this.ticketsBought,
    );
  }

  addReferralPoints(points: bigint): UserInfo {
    return new UserInfo(
      this.points + Number(points),
      this.toClaim,
      this.isCharity,
      this.hasBeenCharity,
      this.donationsToClaim,
      this.isOwner,
      this.royaltiesToClaim,
      this.ticketsBought,
    );
  }

  addTicketsBought(newTickets: Ticket[]): UserInfo {
    return new UserInfo(
      this.points,
      this.toClaim,
      this.isCharity,
      this.hasBeenCharity,
      this.donationsToClaim,
      this.isOwner,
      this.royaltiesToClaim,
      [...newTickets, ...this.ticketsBought],
    );
  }

  clearTicketsBought(): UserInfo {
    return new UserInfo(
      this.points,
      this.toClaim,
      this.isCharity,
      this.hasBeenCharity,
      this.donationsToClaim,
      this.isOwner,
      this.royaltiesToClaim,
      [],
    );
  }
}
